import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import {
  SearchService, BasicSearchParams, ScrollService, ScrollParams, UserService, SongsService, AlbumsService,
  PlaylistService, ArtistService
} from '../api';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import * as _ from 'lodash';

@Component({
  selector: 'app-search-page',
  templateUrl: './search-page.component.html',
  styleUrls: ['./search-page.component.css']
})
export class SearchPageComponent implements OnInit {
  private scrollParams = new ScrollParams();
  private scrollSubscriber = null;
  private searchTerm: string = '';
  private searchParams: BasicSearchParams = new BasicSearchParams();
  private results: any = new Array<any>();
  private loading: boolean = false;
  private totalResults: number = 0;

  constructor(private searchService: SearchService, private cdRef: ChangeDetectorRef, private router: Router,
    private scrollService: ScrollService, private userService: UserService, private songService: SongsService,
    private albumService: AlbumsService, private playlistService: PlaylistService, private artistService: ArtistService,
    private route: ActivatedRoute) {
    this.scrollParams.size = 50;
  }

  ngOnInit() {
    this.route.queryParams.subscribe((queryParams: any) => {
      this.searchTerm = queryParams.q || '';
      this.searchParams.searchArtists = (queryParams.artist === 'true') ? true : false;
      this.searchParams.searchCollections = (queryParams.collection === 'true') ? true : false;
      this.searchParams.searchPlaylists = (queryParams.playlists === 'true') ? true : false;
      this.searchParams.searchSongs = (queryParams.song === 'true') ? true : false;
      this.searchParams.searchUsers = (queryParams.accounts === 'true') ? true : false;
      this.search();
    });
    this.userService.getUserEventEmitter().subscribe((item) => {
      if (item.name === 'user:login') {
        this.searchService.getSearchPreferences().subscribe((res) => {
          localStorage.setItem('searchPreferences', JSON.stringify(res));
          this.searchParams.processPreferences();
          this.searchTerm = '';
          this.results = new Array<any>();
        });
      } else if (item.name === 'user:logout') {
        this.searchParams.processPreferences();
      }
      this.searchTerm = '';
      this.results = new Array<any>();
    });
    this.scrollSubscriber = this.scrollService.onScroll.subscribe((event) => this.search());
    this.searchParams.processPreferences();
    // if (this.results.length > 0) {
    //   this.scrollService.toggleProgressBar(false);
    //   this.loading = false;
    // }
  }

  search() {
    this.loading = true;
    if (this.searchTerm !== '') {
      this.searchService.saveSearchPreference(this.searchParams).subscribe((res) => { });
      this.searchParams.query = this.searchTerm;
      this.searchService.saveSearchQuery(this.searchParams).subscribe((res) => { });
      this.loading = true;
      this.searchService.getSearchResults(this.searchTerm, this.searchParams, this.scrollParams).then((res) => {
        this.totalResults = res.total;
        let ids = [];
        _.keys(res.data).forEach((key) => {
          ids[key] = this.fetchIds(res.data[key], key);
          if (key === 'song') {
            this.songService.getSongsById(ids[key]).subscribe((songs) => {
              this.results.push(...songs);
              this.loading = false;
            });
          } else if (key === 'album') {
            this.albumService.getAlbumsByIds(ids[key]).subscribe((album) => {
              this.results.push(...album);
              this.loading = false;
            });
          } else if (key === 'playlist') {
            this.playlistService.getPlaylistDetailsByIds(ids[key]).subscribe((playlist) => {
              this.results.push(...playlist);
              this.loading = false;
            });
          } else if (key === 'artist') {
            this.artistService.getArtistsByIds(ids[key]).subscribe((artist) => {
              this.results.push(...artist);
              this.loading = false;
            });
          } else if (key === 'account') {
            this.userService.getAccountByIds(ids[key]).subscribe((accounts) => {
              this.results.push(...accounts);
              this.loading = false;
            });
          }
        });
        this.scrollParams.page++;
        this.cdRef.detectChanges();
      }, (err) => {
        this.loading = false;
      });
    }
  }

  handleSearch(event) {
    if (event.searchTerm) {
      this.searchTerm = event.searchTerm;
    }
    this.resetSearch();
    let navigationExtras: NavigationExtras = {
      relativeTo: this.route,
      queryParams: {
        'q': this.searchTerm,
        'song': this.searchParams.searchSongs,
        'collection': this.searchParams.searchCollections,
        'artist': this.searchParams.searchArtists,
        'accounts': this.searchParams.searchUsers,
        'playlists': this.searchParams.searchPlaylists
      },
    };
    this.router.navigate([], navigationExtras);
  }

  navigate(type: string) {
    this.scrollService.closeSideNav();
    let navigationExtras: NavigationExtras = {
      queryParams: { 'q': this.searchTerm },
    };
    if (type === 'songs') {
      this.router.navigate(['/songs'], navigationExtras);
    } else if (type === 'artists') {
      this.router.navigate(['/artists'], navigationExtras);
    } else if (type === 'albums') {
      this.router.navigate(['/collections'], navigationExtras);
    } else if (type === 'playlists') {
      this.router.navigate(['/peoples-playlists'], navigationExtras);
    } else if (type === 'account') {
      this.router.navigate(['/accounts'], navigationExtras);
    }
  }

  fetchIds(hits, domain) {
    let ids = new Array<any>();
    hits.forEach((arrayItem) => {
      if (arrayItem._type === domain) {
        ids.push(arrayItem._id);
      }
    });
    return ids;
  }

  resetSearch() {
    this.scrollParams = new ScrollParams();
    this.scrollParams.size = 50;
    this.results = new Array<any>();
  }

}



// WEBPACK FOOTER //
// ./src/app/search-page/search-page.component.ts